import { useMemo } from 'react';
import { DocumentFieldStatus, LocationStatus } from '@sib/api';
import { useTranslation } from '@sib/i18n';

export const useLocationStatusSelectOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        value: LocationStatus.Active,
        label: t('enums.locationStatus.active'),
      },
      {
        value: LocationStatus.Monitored,
        label: t('enums.locationStatus.monitored'),
      },
      {
        value: LocationStatus.Sold,
        label: t('enums.locationStatus.sold'),
      },
      {
        value: LocationStatus.Closed,
        label: t('enums.locationStatus.closed'),
      },
      {
        value: LocationStatus.UnderConstruction,
        label: t('enums.locationStatus.underConstruction'),
      },
      {
        value: LocationStatus.NotActive,
        label: t('enums.locationStatus.notActive'),
      },
    ],
    [t]
  );
};

export const useDocumentFieldStatusSelectOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        value: DocumentFieldStatus.COMPLETE,
        label: t('enums.documentFieldStatus.complete'),
      },
      {
        value: DocumentFieldStatus.MISSING_FIELDS,
        label: t('enums.documentFieldStatus.missingFields'),
      },
      {
        value: DocumentFieldStatus.UPLOAD_INVOICES,
        label: t('enums.documentFieldStatus.uploadInvoices'),
      },
      {
        value: DocumentFieldStatus.NOT_APPLICABLE_REQUESTED,
        label: t('enums.documentFieldStatus.naRequested'),
      },
      {
        value: DocumentFieldStatus.NOT_APPLICABLE,
        label: t('enums.documentFieldStatus.notApplicable'),
      },
    ],
    [t]
  );
};
